<template>
  <div class="oqc-pc">
    <inspection-form
      ref="inspectionRef"
      @updateTable="handleUpdateTable"
      type="oqc"
      :closedLoopAuthority="false"
    ></inspection-form>
    <div class="space df both-side">
      <a-space>
        <a-date-picker
          v-model:value="requestPayload.localDate"
          placeholder="生产日期"
          allowClear
          style="width: 120px"
          @change="hanldeSelectDate($event, 'localDate')"
        ></a-date-picker>

        <a-date-picker
          v-model:value="requestPayload.shippedDate"
          placeholder="发货日期"
          style="width: 120px"
          allowClear
          @change="hanldeSelectDate($event, 'shippedDate')"
        >
        </a-date-picker>

        <a-range-picker
          v-model:value="rangePickerValue"
          @change="handleUpdateRange"
          style="width: 220px"
        />

        <a-select
          v-model:value="requestPayload.purpose"
          :options="purposeOption"
          placeholder="用途"
          style="width: 120px"
          allowClear
          @change="handleSearch"
        >
        </a-select>

        <a-input
          v-model:value="requestPayload.batchNumber"
          placeholder="生产批号"
          style="width: 150px"
          allowClear
          @change="handleSearch"
        >
        </a-input>

        <a-cascader
          v-model:value="modelSpecifications"
          placeholder="型号规格"
          :options="modelSpecificationsOption"
          allowClear
          @change="handleSelectModel"
        >
        </a-cascader>

        <a-select
          v-model:value="requestPayload.status"
          placeholder="状态"
          allowClear
          @change="handleSearch"
        >
          <a-select-option value="未检">未检</a-select-option>
          <a-select-option value="合格">合格</a-select-option>
          <a-select-option value="不合格">不合格</a-select-option>
        </a-select>
        <a-input
          v-model:value="requestPayload.search"
          placeholder="搜索"
          allowClear
          @change="handleSearch"
        ></a-input>
      </a-space>

      <a-space>
        <a-button size="small" type="default" @click="exportOQCData"> 导出数据 </a-button>
        <a-button size="small" type="primary" @click="handleUpdateOQC(null)"> 新增 </a-button>
      </a-space>
    </div>

    <div class="space">
      <a-table
        :data-source="table.data"
        bordered
        :pagination="pagination"
        :columns="columns"
        :scroll="{ y: 'calc(100vh - 390px)', x: 'calc(100vw - 300px)' }"
        rowKey="id"
        class="space"
      >
        <template #reason1="{ record }">
          <div v-if="record.reason1">
            <div v-for="(item, index) in record.reason1" :key="index">
              {{ item }}
            </div>
          </div>
        </template>
        <template #reason2="{ record }">
          <div v-if="record.reason2">
            <div v-for="(item, index) in record.reason2" :key="index">
              {{ item }}
            </div>
          </div>
        </template>
        <template #solution1="{ record }">
          <div v-if="record.solution1">
            <div v-for="(item, index) in record.solution1" :key="index">
              {{ item }}
            </div>
          </div>
        </template>
        <template #solution2="{ record }">
          <div v-if="record.solution2">
            <div v-for="(item, index) in record.solution2" :key="index">
              {{ item }}
            </div>
          </div>
        </template>
        <template #question1="{ record }">
          <div v-for="(img, index) in record.issuesImg1" :key="index">
            <a-image :width="50" :src="img" />
          </div>
          <div v-for="(video, index) in record.issuesVideo1" :key="index">
            <video :src="video" controls width="120" :key="video"></video>
          </div>
          <div v-for="(item, index) in record.issuesDesc1" :key="index">
            {{ item }}
          </div>
        </template>
        <template #question2="{ record }">
          <div v-for="(img, index) in record.issuesImg2" :key="index">
            <a-image :width="50" :src="img" />
          </div>
          <div v-for="(video, index) in record.issuesVideo2" :key="index">
            <video :src="video" controls width="120" :key="video"></video>
          </div>
          <div v-for="(item, index) in record.issuesDesc2" :key="index">
            {{ item }}
          </div>
        </template>
        <template #questionType2="{ record }">
          <div v-if="record.questionType2">
            <div v-for="(item, index) in record.questionType2" :key="index">
              {{ item }}
            </div>
          </div>
        </template>
        <template #questionType1="{ record }">
          <div v-if="record.questionType1">
            <div v-for="(item, index) in record.questionType1" :key="index">
              {{ item }}
            </div>
          </div>
        </template>

        <template #status="{ record }">
          <a-tag :color="setColor(record.status)">{{ record.status }}</a-tag>
        </template>

        <template #file="{ record }">
          <a-button v-if="record.annex" size="small" type="primary" @click="downloadFile(record)">
            下载附件
          </a-button>
        </template>

        <template #action="{ record }">
          <!-- <a-button
            @click="handleUpdateOQC(record)"
            type="primary"
            size="small"
          >
            编辑
          </a-button> -->

          <a-dropdown>
            <template #overlay>
              <a-menu @click="handleMenuClick($event, record)">
                <a-menu-item key="包装信息">包装信息</a-menu-item>
                <a-menu-item key="质检问题" :disabled="record.status !== '不合格'"
                  >质检问题</a-menu-item
                >
              </a-menu>
            </template>
            <a-button size="small" type="primary">
              编辑
              <DownOutlined />
            </a-button>
          </a-dropdown>
        </template>
      </a-table>
    </div>

    <!-- <div class="pagination">
      <a-pagination
        size="small"
        :total="table.total"
        :show-total="(total) => `共 ${total} 条`"
        v-model:pageSize="table.lineNum"
        v-model:current="table.pageNum"
        @change="hanldeUpdatePageNum"
      />
    </div> -->
  </div>

  <oqc-form ref="oqcFormRef" @handleUpdateTable="handleUpdateTable"></oqc-form>
</template>
<script>
import { defineComponent, inject, reactive, ref, watch } from "vue";
import { debounce, Toast } from "@/utils";
import { useTable } from "@/views/notice/serve/table";
import { download } from "@/views/rdmanagement/serve/index";
import oqcForm from "@/views/productDaily/warehouse/oqcForm.vue";
import { getOQCList, exportOQC } from "@/request/view/warehouse";
import { modelSpecificationsOption } from "@/views/productDaily/serve/option";
import { setmediaInfo, purposeOption } from "@/views/productDaily/warehouse/option";
import { DownOutlined } from "@ant-design/icons-vue";
import inspectionForm from "@/views/productDaily/components/product/components/qualityInspection/form.vue";

export default defineComponent({
  components: {
    oqcForm,
    inspectionForm,
    DownOutlined,
  },
  setup(props, context) {
    const oqcFormRef = ref();
    const warehouseEditAuthority = inject("warehouseEditAuthority", false);
    const rangePickerValue = ref([]);
    const inspectionRef = ref();
    const setColor = (status) => {
      let color = "";
      switch (status) {
        case "未检":
          color = "orange";
          break;
        case "不合格":
          color = "#f50";
          break;
        case "合格":
          color = "#87d068";
          break;
        default:
          break;
      }
      return color;
    };

    const modelSpecifications = ref([]);

    const pagination = ref({
      current: 1,
      defaultPageSize: 10,
      total: 0,
      pageSizeOptions: ["10", "20", "50", "100"],
      showTotal: (total) => `共 ${total} 条`,
      showQuickJumper: true,
      showSizeChanger: true,
      size: "small",
      onChange: (page, pageSize) => {
        changePagination(page);
      },
    });

    const changePagination = (page) => {
      pagination.value.current = page;
    };

    const {
      requestConfig,
      table,
      requestPayload,
      initPayload,
      getListData,
      searchData,
      deleteRecords,
      hanldeUpdatePageNum,
    } = useTable();

    initPayload({
      batchNumber: null,
      endDate: null,
      inspectionFrequency: null,
      // lineNum: null,
      localDate: null,
      modelSpecifications: null,
      purpose: null,
      // pageNum: null,
      produceOrTpc: inject("produceOrTpc", null),
      questionType: null,
      search: null,
      startDate: null,
      status: null,
    });

    requestConfig.pull_fn = getOQCList;

    const columns = [
      {
        title: "生产批号",
        dataIndex: "batchNumber",
        align: "center",
        width: "120px",
        fixed: "left",
      },
      {
        title: "型号",
        dataIndex: "modelSpecifications",
        align: "center",
        width: "120px",
      },
      { title: "机身号", dataIndex: "serial", align: "center", width: "160px" },
      {
        title: "状态",
        slots: {
          customRender: "status",
        },
        align: "center",
        width: "100px",
      },
      {
        title: "客户信息",
        dataIndex: "customerInfo",
        align: "center",
        width: "100px",
      },
      {
        title: "收货地址",
        dataIndex: "address",
        align: "center",
        width: "180px",
      },
      {
        title: "生产日期",
        dataIndex: "localDate",
        align: "center",
        width: "120px",
      },
      {
        title: "发货日期",
        dataIndex: "shippedDate",
        align: "center",
        width: "120px",
      },
      {
        title: "附件",
        slots: {
          customRender: "file",
        },
        align: "center",
        width: "100px",
      },
      {
        title: "总装调试SN号",
        dataIndex: "assembleDebugsnNumber",
        align: "center",
        width: "200px",
      },
      {
        title: "对接人",
        dataIndex: "contactPerson",
        align: "center",
        width: "120px",
      },
      {
        title: "物流信息",
        dataIndex: "logisticsInfo",
        align: "center",
        width: "160px",
      },
      { title: "备注", dataIndex: "notes", align: "center", width: "100px" },
      { title: "用途", dataIndex: "purpose", align: "center", width: "100px" },
      {
        title: "第1次送检问题",
        children: [
          {
            title: "问题",
            slots: { customRender: "question1" },
            align: "center",
            width: 260,
          },
          {
            title: "问题类型",
            slots: { customRender: "questionType1" },
            align: "center",
            width: 100,
          },

          {
            title: "送检人",
            dataIndex: "inspectionPersonnel1",
            width: 90,
            align: "center",
          },
          {
            title: "质检人",
            dataIndex: "qualityPersonnel1",
            width: 90,
            align: "center",
          },
          {
            title: "原因",
            dataIndex: "reason1",
            width: 90,
            align: "center",
          },
          {
            title: "解决方案",
            dataIndex: "solution1",
            width: 120,
            align: "center",
          },
        ],
      },
      {
        title: "第2次送检问题",
        children: [
          {
            title: "问题",
            slots: { customRender: "question2" },
            align: "center",
            width: 260,
          },
          {
            title: "问题类型",
            slots: { customRender: "questionType2" },
            align: "center",
            width: 100,
          },
          {
            title: "送检人",
            dataIndex: "inspectionPersonnel2",
            width: 90,
            align: "center",
          },
          {
            title: "质检人",
            dataIndex: "qualityPersonnel2",
            width: 90,
            align: "center",
          },
          {
            title: "原因",
            dataIndex: "reason2",
            width: 90,
            align: "center",
          },
          {
            title: "解决方案",
            dataIndex: "solution2",
            width: 120,
            align: "center",
          },
        ],
      },
      {
        title: "操作",
        slots: {
          customRender: "action",
        },
        fixed: "right",
        align: "center",
        width: "100px",
      },
    ];

    // 下载附件
    const downloadFile = (record) => {
      download(record.annex, `${record.serial}附件`);
    };

    const handleUpdateTable = () => {
      getListData({ unPagingRequest: true }).then(() => {
        setmediaInfo(table.data);
      });
    };
    const hanldeSelectDate = (e, type) => {
      const stringTime = e ? e.format("YYYY-MM-DD") : null;
      requestPayload[type] = stringTime;

      if (stringTime) {
        requestPayload.startDate = null;
        requestPayload.endDate = null;
      }
      // requestPayload.pageNum = 1;
      handleUpdateTable();
    };

    const handleSearch = debounce(() => {
      // requestPayload.pageNum = 1;
      handleUpdateTable();
    }, 50);

    const handleSelectModel = (e) => {
      const [project, model] = e;
      requestPayload.modelSpecifications = model;
      // requestPayload.pageNum = 1;
      handleUpdateTable();
    };

    const handleUpdateRange = (e, stringTime) => {
      const [startTime, endTime] = stringTime;
      if (startTime && endTime) {
        requestPayload.startDate = startTime;
        requestPayload.endDate = endTime;
        requestPayload.localDate = null;
        requestPayload.shippedDate = null;
        // requestPayload.pageNum = 1;
        handleUpdateTable();
        return;
      }

      requestPayload.startDate = null;
      requestPayload.endDate = null;
      // requestPayload.pageNum = 1;
      handleUpdateTable();
    };

    const handleUpdateOQC = (record) => {
      const title = record ? "修改发货指令单" : "新增发货指令单";
      const data = record;
      const type = record ? "update" : "insert";
      oqcFormRef.value.showModal(type, {
        title,
        data,
      });
    };

    const handleMenuClick = (e, record) => {
      const type = e.key;

      if (type === "包装信息") {
        handleUpdateOQC(record);
      } else if (type === "质检问题") {
        inspectionRef.value.openModal("editPQC", record);
      }
    };

    const activeKey = inject("activeKey", null);

    const exportOQCData = () => {
      exportOQC().then((res) => {
        const link = document.createElement("a");
        const blob = new Blob([res], { type: "application/vnd.ms-excel" });
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `天鹅出货统计.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        Toast("success", "下载成功", 3);
      });
    };

    watch(
      () => activeKey,
      (val) => {
        if (val && val.value === "oqc") {
          modelSpecifications.value.length = 0;
          requestPayload.endDate = null;
          requestPayload.inspectionFrequency = null;
          requestPayload.modelSpecifications = null;
          requestPayload.produceOrTpc = inject("produceOrTpc", null);
          requestPayload.questionType = null;
          requestPayload.search = null;
          requestPayload.startDate = null;
          requestPayload.status = null;
          // table.pageNum = 1;
          handleUpdateTable();
        }
      },
      {
        deep: true,
        immediate: true,
      }
    );

    return {
      table,
      inspectionRef,
      columns,
      requestPayload,
      oqcFormRef,
      purposeOption,
      exportOQCData,
      pagination,
      handleMenuClick,
      rangePickerValue,
      handleSelectModel,
      warehouseEditAuthority,
      modelSpecifications,
      modelSpecificationsOption,
      downloadFile,
      handleSearch,
      setColor,
      hanldeSelectDate,
      handleUpdateRange,
      handleUpdateOQC,
      handleUpdateTable,
      hanldeUpdatePageNum,
    };
  },
});
</script>

<style lang="less" scoped>
.oqc-pc {
  width: 100%;
  height: 100%;

  .space {
    margin-bottom: 10px;
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
